import CustomElement from '../core/custom.js'
import Emitter from '../core/emitter.js'
import Viewport from '../stores/viewport.js'
import getOffsetTop from '../utilities/getOffsetTop.js'
import remapRange from '../utilities/remapRange.js'
import clamp from '../utilities/clamp.js'

import resolveConfig from 'tailwindcss/resolveConfig'
import customConfig from '../../../tailwind.config.js'
import { easeInOutQuad, easeOutSine } from '../utilities/easings.js'
const tailwindConfig = resolveConfig(customConfig)

export default window.customElements.define(
  'block-case-study-header',
  class extends CustomElement {
    isSmall = true
    isNext = false
    ready = true

    constructor() {
      super()

      this._onResize = this.onResize.bind(this)
      this._onUpdate = this.onUpdate.bind(this)
      this._onTransitionLeave = this.onTransitionLeave.bind(this)
      this._onTransitionInDone = this.onTransitionInDone.bind(this)
    }

    connectedCallback() {
      super.connectedCallback()

      this.$background = this.querySelector('.js-background')
      this.$desc = this.querySelector('.js-desc')

      if (!this.$background) {
        return console.warn(
          'BlockCaseStudyHeader: This component must be have a .js-background child',
          this
        )
      }

      if (!this.$desc) {
        return console.warn(
          'BlockCaseStudyHeader: This component must be have a .js-desc child',
          this
        )
      }

      Emitter.on('resize', this._onResize)
      Emitter.on('update', this._onUpdate)

      Emitter.on('transition:leave', this._onTransitionLeave)
      Emitter.on('transition-in:done', this._onTransitionInDone)

      this.isNext = !!this.dataset.isNext
      this._onResize()
    }

    disconnectedCallback() {
      super.disconnectedCallback()

      Emitter.off('resize', this._onResize)
      Emitter.off('update', this._onUpdate)
      Emitter.off('transition-in:done', this._onTransitionInDone)
    }

    onBreakpoint({ viewport }) {
      this.isSmall = viewport.to('lg')
    }

    onResize() {
      this._offsetTop = getOffsetTop(this)
      // this._height = Viewport.height // this.offsetHeight
      this._height = this.offsetHeight

      this._initScale = this.isSmall
        ? 0.62
        : (Viewport.width /
            (2 * parseInt(tailwindConfig.theme.spacing.wrapper) +
              Viewport.width)) *
          0.5

      this._descHeight = this.$desc.offsetHeight
    }

    onTransitionLeave() {
      this.ready = false
    }

    onTransitionInDone() {
      this.ready = true
      this.onResize()
    }

    onUpdate() {
      if (!this.ready) return

      this._scale = remapRange(
        this._offsetTop,
        this._offsetTop + Viewport.height,
        0,
        1,
        clamp(
          window.scrollY,
          this._offsetTop,
          this._offsetTop + Viewport.height
        )
      )
      this._scale = easeOutSine(this._scale)
      this._scale = remapRange(0, 1, this._initScale, 1, this._scale)

      if (!this.isSmall) {
        if (!this.isNext) {
          this._translateX = remapRange(
            this._offsetTop,
            this._offsetTop + Viewport.height,
            0,
            1,
            window.scrollY
          )
          this._translateX = clamp(this._translateX, 0, 1)
          this._translateX = easeInOutQuad(this._translateX)
          this._translateX = remapRange(0, 1, -24, 0, this._translateX)
          this._translateX = clamp(this._translateX, -24, 0)
        } else {
          this._translateX = -24
        }
      } else {
        this._translateX = 0
      }

      if (!this.isSmall) {
        this._translateY = remapRange(
          this._offsetTop,
          this._offsetTop + Viewport.height,
          -this._descHeight,
          0,
          window.scrollY
        )
        this._translateY = clamp(this._translateY, -this._descHeight, 0)
      } else {
        this._translateY = 0
      }

      this.$background.style.transform = `translate(${this._translateX}px, ${this._translateY}px) scale(${this._scale})`
      this.$background.style.opacity = 1
    }
  }
)
